/**
 * Feature flag type definitions.
 */

export interface FeatureFlags {
  // Navigation visibility
  show_stats_leaderboard: boolean;
  show_managers_page: boolean;
  show_transactions_page: boolean;
  show_games_page: boolean;
  show_todays_games: boolean;
  show_wbc: boolean;
  show_scoring_101: boolean;

  // Feature toggles
  enable_scorecard_upload: boolean;
  show_scorecard_comments: boolean;
  show_notifications: boolean;
  show_dimensional_scores: boolean;
  show_advanced_filters: boolean;
  show_player_links: boolean;
  show_tip_jar: boolean;

  // Push notifications
  enable_push_notifications: boolean;

  // System flags
  maintenance_mode: boolean;
  show_beta_banner: boolean;

  // Beta feedback flags
  beta_banner_enabled: boolean;
  beta_feedback_widget_enabled: boolean;
  beta_feedback_upload_enabled: boolean;
  beta_feedback_search_enabled: boolean;
  beta_feedback_detail_enabled: boolean;
  beta_feedback_onboarding_enabled: boolean;
  beta_feedback_scorebook_enabled: boolean;
  beta_feedback_edit_enabled: boolean;

  // Allow dynamic flags
  [key: string]: boolean;
}

/**
 * Default flag values used when API is unavailable.
 */
export const DEFAULT_FLAGS: FeatureFlags = {
  show_stats_leaderboard: false,
  show_managers_page: false,
  show_transactions_page: false,
  show_games_page: false,
  show_todays_games: false,
  show_wbc: false,
  show_scoring_101: false,
  enable_scorecard_upload: true,
  show_scorecard_comments: false,
  show_notifications: false,
  show_dimensional_scores: false,
  show_advanced_filters: false,
  show_player_links: false,
  show_tip_jar: false,
  enable_push_notifications: false,
  maintenance_mode: false,
  show_beta_banner: true,
  beta_banner_enabled: false,
  beta_feedback_widget_enabled: false,
  beta_feedback_upload_enabled: false,
  beta_feedback_search_enabled: false,
  beta_feedback_detail_enabled: false,
  beta_feedback_onboarding_enabled: false,
  beta_feedback_scorebook_enabled: false,
  beta_feedback_edit_enabled: false,
};

/**
 * Type guard to check if a key is a known feature flag.
 */
export function isKnownFlag(key: string): boolean {
  return key in DEFAULT_FLAGS;
}
